// jshint ignore: start
/* eslint-disable */

(function ($) {

  var products = [];
  var currentproductname = '';
  var productsloaded = 0;

  var issues = [];
  var openissues = [];
  var issuesloaded = 0;

  var isExpanded = 0;

  var queryparams = (function (a) {
    if (a === '')
      return {};
    var b = {};
    for (var i = 0; i < a.length; ++i) {
      var p = a[i].split('=', 2);
      if (p.length === 1)
        b[p[0]] = '';
      else
        b[p[0]] = encodeURIComponent(p[1].replace(/\+/g, ' '));
    }
    return b;
  }(window.location.search.substr(1).split('&')));

  function ExpandCollapseParent(id) {
    if (id) {
      var parent = document.getElementById(id);
      var expand = 1;
      if (parent) {
        expand = parent.getAttribute('expand') === '1';
        if (expand) {
          parent.setAttribute('expand', '0');
          parent.firstElementChild.firstElementChild.setAttribute('class', 'sf-tip uxicon uxicon-drop-up');
        } else {
          parent.setAttribute('expand', '1');
          parent.firstElementChild.firstElementChild.setAttribute('class', 'sf-tip uxicon uxicon-drop-down');
        }
      }

      var body = document.getElementById('issuegridbody');
      if (body) {
        var e = body.firstChild;
        while (e) {
          var parent = e.getAttribute('parentid');
          if (parent && parent === id) {
            if (expand)
              e.setAttribute('style', 'height:30px;');
            else
              e.setAttribute('style', 'display:none;height:30px;');
          }
          e = e.nextSibling;
        }
      }
    }
  }

  function LoadProducts(locale) {
    var x = new XMLHttpRequest();
    x.onreadystatechange = function () {
      if (x.readyState === XMLHttpRequest.DONE) {
        productsloaded = 1;

        if (x.status === 200) {
          products = JSON.parse(x.responseText);
          products = products[0];
        }

        if (products && queryparams.hasOwnProperty('productid')) {
          var pid = queryparams.productid;
          for (var n = 0 ; n < products.length; ++n) {
            if (products[n].productid === pid) {
              currentproductname = products[n].productname;
            }
          }
        } else {
          InjectProducts();
        }

        setTimeout(LoadProducts, 60000, locale);
      }
    };
    x.open('POST', requestContext.hostPath + '/ajax/statusProducts', true);
    x.setRequestHeader('Content-Type', 'application/json;charset=utf-8');
    x.setRequestHeader('X-CSRF-Token', $('#_csrf').val());
    x.send(JSON.stringify({
      Method: 'GetProducts',
      Parameters: [{
        locale: locale
      }],
      ReturnValue: null
    }));
  }

  function LoadIssues(locale) {
    var end = GetUTCDate(new Date());
    var start = new Date(end.getFullYear(), end.getMonth(), end.getDate() - 4, 0, 0, 0, 0);
    var x = new XMLHttpRequest();
    x.onreadystatechange = function () {
      if (x.readyState === XMLHttpRequest.DONE) {
        if (x.status === 200) {
          issues = JSON.parse(x.responseText);
          issues = issues[0];
          CleanupIssues();
        }

        issuesloaded = 1;
        InjectIssues();

        setTimeout(LoadIssues, 60000, locale);
      }
    };
    x.open('POST', requestContext.hostPath + '/ajax/statusIssues', true);
    x.setRequestHeader('Content-Type', 'application/json;charset=utf-8');
    x.setRequestHeader('X-CSRF-Token', $('#_csrf').val());
    x.send(JSON.stringify({
      Method: 'ReadIssues',
      Parameters: [{
        locale: locale
      }, {
        startdate: start.toJSON().slice(0, 10)
      }, {
        enddate: end.toJSON().slice(0, 10)
      }],
      ReturnValue: null
    }));
  }

  function CleanupIssues() {
    var temp = [];
    openissues.length = 0;

    for (var n = 0 ; n < issues.length; ++n) {
      var issue = issues[n];

      if (!issue.hasOwnProperty('creationdate') ||
              !issue.hasOwnProperty('locale') ||
              !issue.hasOwnProperty('message') ||
              !issue.hasOwnProperty('products') ||
              issue.products.length === 0) {
        continue;
      }

      if (!issue.hasOwnProperty('updates')) {
        issue.updates = [];
      }

      var updates = [];

      if (issue.updates.length === 0) {
        updates = [{
          creationtime: issue.creationdate,
          locale: issue.locale,
          message: issue.message,
          messageid: 0,
          updatekind: 1
        }];
      }

      var isopen = 1;
      for (var i = 0 ; i < issue.updates.length; ++i) {
        var update = issue.updates[i];
        if (update.hasOwnProperty('creationtime') &&
                  update.hasOwnProperty('locale') &&
                  update.locale === issue.locale &&
                  update.hasOwnProperty('message') &&
                  update.hasOwnProperty('updatekind')) {
          updates.push(update);
        }
      }

      updates.sort(SortUpdatesComparison);

      issue.updates.length = 0;
      issue.updates = updates.slice(0);

      temp.push(issue);
      if (!issue.resolveddate) {
        openissues.push(issue);
      }
    }

    issues.length = 0;
    issues = temp.slice(0, temp.length);
  }

  function LocalizeText() {

    var qpid = queryparams.productid;
    var productName = '';

    if (qpid && (qpid / 1) > 0) {
      for (var i = 0 ; i < products.length; ++i) {
        if (products[i].productid === (qpid / 1)) {
          productName = products[i].productname;
          break;
        }
      }
    }

    var e = document.getElementById('issuehistory');
    if (e && locstr.hasOwnProperty('issuehistory')) {
      e.innerHTML = locstr.issuehistory;
    }

    e = document.getElementById('issuetitle');
    if (e && locstr.hasOwnProperty('issuetitle')) {
      e.innerHTML = locstr.issuetitle;
    }

    e = document.getElementById('issuesubtitle');
    if (e && locstr.hasOwnProperty('issuesubtitle')) {
      e.innerHTML = locstr.issuesubtitle;
    }

    e = document.getElementById('resolved');
    if (e && locstr.hasOwnProperty('resolved')) {
      e.innerHTML = locstr.resolved + ':';
    }

    e = document.getElementById('reported');
    if (e && locstr.hasOwnProperty('reported')) {
      e.innerHTML = locstr.reported + ' ' + productName;
    }

    e = document.getElementById('latestupdates');
    if (e && locstr.hasOwnProperty('latestupdates')) {
      e.innerHTML = locstr.latestupdates;
    }

    e = document.getElementById('chat');
    if (e && locstr.hasOwnProperty('chat')) {
      e.setAttribute('title', locstr.chat);
    }

    e = document.getElementById('related');
    if (e && locstr.hasOwnProperty('related')) {
      e.innerHTML = locstr.related + ': ';
    }

    e = document.getElementById('showhide');
    if (e) {
      var state = e.getAttribute('state');
      if (state && locstr.hasOwnProperty(state)) {
        e.innerHTML = locstr[state];
      }
    }

    e = document.getElementById('utcmessage');
    if (e && locstr.hasOwnProperty('utcmessage')) {
      e.innerHTML = locstr.utcmessage;
    }
  }

  function InjectIssues() {
    if (!issuesloaded)
      return !1;

    if (!queryparams.hasOwnProperty('productid')) {
      if (openissues && openissues.length > 0) {
        var summary = CreateIssuesSummary();
        var clear = document.getElementById('allclear');
        if (clear) {
          clear.innerHTML = '';
        }

        var host = document.getElementById('contenthost');
        if (summary && host) {

          var old = document.getElementById('issuesummarycard');
          if (old) {
            old.parentElement.removeChild(old);
          }

          if (host.firstChild)
            host.insertBefore(summary, host.firstChild);
          else
            host.appendChild(summary);
        }
      } else {
        var old = document.getElementById('issuesummarycard');
        if (old) {
          old.parentElement.removeChild(old);
        }
        var elem = document.getElementById('allclear');
        var data = document.getElementById('allclearelements');
        if (elem && data) {
          elem.innerHTML = data.innerHTML;
        }
      }
      AddIssueGridLinks();
    } else {
      var e = document.getElementById('allclearelements');
      if (e) { e.parentElement.removeChild(e); }
      ShowBreadcrumbs();
      CreateIssueDetails();
    }
    LocalizeText();

  }

  function InjectProducts() {
    if (!productsloaded)
      return !1;

    var host = document.getElementById('contenthost');

    if (products && host) {
      var card = CreateCard('status-card');
      card.setAttribute('id', 'gridcard');
      var row = document.createElement('div');
      row.setAttribute('class', 'row');
      var header = document.createElement('div');
      header.setAttribute('class', 'col-md-12 col-lg-12 col-sm-12 col-xs-12');
      var headerContent = document.createElement('h2');
      headerContent.setAttribute('id', 'issuehistory');
      headerContent.setAttribute('style', 'margin-top:0;');
      header.appendChild(headerContent);
      row.appendChild(header);
      var utcrow = document.createElement('small');
      utcrow.setAttribute('id', 'utcmessage');

      card.appendChild(row);
      card.appendChild(utcrow);

      var tbl = CreateProductsGrid();
      if (tbl) {
        card.appendChild(tbl);
      }

      AddIssueGridLinks();

      var old = document.getElementById('gridcard');
      if (old) {
        old.parentElement.removeChild(old);
      }

      host.appendChild(card);

      InjectIssues();
      LocalizeText();
    }
  }

  function ShowBreadcrumbs() {
    var element = document.getElementById('breadcrumb');
    if (element) {
      element.setAttribute('style', 'display:inherit;');
    }
  }

  function CreateIssueDetails() {
    var host = document.getElementById('contenthost');
    if (issues && host) {
      var locale = requestContext.market;

      for (var n = 0; n < issues.length; ++n) {
        var issue = issues[n];
        var ignore = 1;
        for (var i = 0; i < issue.products.length; ++i) {
          var pid = issue.products[i].productid;
          var qpid = queryparams.productid / 1;
          if (pid && (pid === qpid)) {
            ignore = 0;
          }
        }

        if (ignore) { continue; }

        var card = CreateCard('status-card');
        card.setAttribute('id', 'issuedetailscard');

        if (issue.resolveddate) {
          var resolvedrow = document.createElement('div');
          resolvedrow.setAttribute('class', 'row');
          resolvedrow.setAttribute('style', 'height:50px;vertical-align:middle;');

          var resolvedicon = document.createElement('span');
          resolvedicon.setAttribute('class', 'uxicon uxicon-ok col-sm-1 col-md-1 col-lg-1 hidden-sm-down');
          resolvedicon.setAttribute('style', 'font-size:50px;color:#008a32;margin:0px;');

          resolvedrow.appendChild(resolvedicon);

          var resolvedtext = document.createElement('h3');
          resolvedtext.setAttribute('id', 'resolved');
          resolvedtext.setAttribute('style', 'margin:0px;padding-top:15px;');
          resolvedtext.setAttribute('class', 'col-xs-11');
          resolvedrow.appendChild(resolvedtext);

          card.appendChild(resolvedrow);
        }

        var issuetitlerow = document.createElement('div');
        issuetitlerow.setAttribute('class', 'row');

        var desc = document.createElement('h3');
        desc.setAttribute('class', 'col-xs-8 col-sm-8 col-md-8 col-lg-8');
        desc.setAttribute('style', 'margin:5px;');
        desc.setAttribute('id', 'reported');
        issuetitlerow.appendChild(desc);

        var combo = document.createElement('div');
        combo.setAttribute('class', 'row col-xs-4 col-sm-4 col-md-4 col-lg-4');

        var latest = document.createElement('h3');
        latest.setAttribute('id', 'latestupdates');
        latest.setAttribute('style', 'float:left;margin:5px;');
        combo.appendChild(latest);

        var span = document.createElement('span');
        span.setAttribute('class', 'sf-tip uxicon uxicon-comments');
        span.setAttribute('id', 'chat');
        span.setAttribute('style', 'color:#5b79b1;font-size:25px;float:left;margin:5px;cursor: pointer;');
        span.setAttribute('onclick', 'gdstatus.LoadSupport();');

        // Display Chat only for en-XX markets
        if (locale.indexOf('en-') !== -1) {
          combo.appendChild(span);
        }

        issuetitlerow.appendChild(combo);

        card.appendChild(issuetitlerow);

        var divide = document.createElement('div');
        divide.setAttribute('style', 'height:4px;background:#e6e6e6;margin:0px;');
        card.appendChild(divide);

        var issuecontentsrow = document.createElement('div');
        issuecontentsrow.setAttribute('class', 'row');

        var issuecontents = document.createElement('div');
        issuecontents.setAttribute('class', 'col-xs-8 col-sm-8 col-md-8 col-lg-8');

        var desc = document.createElement('div');
        desc.setAttribute('style', 'margin-top:10px;margin-bottom:10px;');
        desc.innerHTML = issue.message;

        issuecontents.appendChild(desc);

        var line = document.createElement('div');
        line.setAttribute('style', 'height:2px;background:#e6e6e6;margin:0px;');
        issuecontents.appendChild(line);

        var related = document.createElement('div');
        related.setAttribute('id', 'related');
        related.setAttribute('style', 'font-weight:700;font-size:14px;margin-top:10px;margin-bottom:10px;');

        issuecontents.appendChild(related);

        var issuetimeline = document.createElement('div');
        issuetimeline.setAttribute('class', 'col-xs-4 col-sm-4 col-md-4 col-lg-4');

        for (var i = 0 ; i < issue.updates.length; ++i) {
          var update = issue.updates[i];

          var data = document.createElement('div');
          data.setAttribute('class', 'row');
          data.setAttribute('style', 'padding-top:8px;padding-bottom:8px;');

          var icon = document.createElement('span');
          icon.setAttribute('title', update.message);

          var state = document.createElement('div');
          state.setAttribute('style', 'font-size:12px;display:inline;font-weight:600;margin-left:10px;');

          var udt = document.createElement('div');
          udt.setAttribute('style', 'font-size:10px;font-weight:600;margin-left:10px;margin-top:10px;');
          udt.innerHTML = update.creationtime + ' UTC';

          switch (update.updatekind) {
            case 1:
              icon.setAttribute('class', 'uxicon col-xs-2 col-sm-2 col-md-1 col-lg-1 uxicon-information');
              icon.setAttribute('style', 'font-size:25px;padding-top:15px;');
              state.innerHTML = locstr.typecreated;
              break;
            case 2:
              icon.setAttribute('class', 'uxicon col-xs-2 col-sm-2 col-md-1 col-lg-1 uxicon-information');
              icon.setAttribute('style', 'font-size:25px;padding-top:15px;');
              state.innerHTML = locstr.typeupdated;
              break;
            case 3:
              icon.setAttribute('class', 'uxicon col-xs-2 col-sm-2 col-md-1 col-lg-1 uxicon-ok');
              icon.setAttribute('style', 'color:#008a32;font-size:25px;padding-top:15px;');
              state.innerHTML = locstr.typeresolved;
              break;
            default:
              icon.setAttribute('class', 'uxicon col-xs-2 col-sm-2 col-md-1 col-lg-1 uxicon-information');
              icon.setAttribute('style', 'font-size:25px;padding-top:15px;');
              state.innerHTML = locstr.typeupdated;
              break;
          }

          data.appendChild(icon);

          var details = document.createElement('div');
          details.setAttribute('class', 'col-xs-10 col-sm-10 col-md-11 col-lg-11');

          details.appendChild(udt);
          details.appendChild(state);
          data.appendChild(details);

          issuetimeline.appendChild(data);
        }


        issuecontentsrow.appendChild(issuecontents);
        issuecontentsrow.appendChild(issuetimeline);

        card.appendChild(issuecontentsrow);

        var old = document.getElementById('issuedetailscard');
        if (old) {
          old.parentElement.removeChild(old);
        }

        host.appendChild(card);
      }
    }
  }

  function CreateProductsGrid() {
    var locale = requestContext.market;
    var tbl = document.createElement('table');
    tbl.setAttribute('class', 'table table-bordered table-hover');
    tbl.setAttribute('style', 'width:100%;');
    tbl.setAttribute('id', 'issuesgrid');
    var header = document.createElement('thead');
    var body = document.createElement('tbody');
    body.setAttribute('id', 'issuegridbody');
    var row = document.createElement('tr');

    var thElem = document.createElement('th');
    thElem.setAttribute('class', 'status-grid-header');
    row.appendChild(thElem);

    var end = GetUTCDate(new Date());
    end.setHours(0, 0, 0, 0);
    var start = new Date(end.getFullYear(), end.getMonth(), end.getDate() - 4, 0, 0, 0, 0);

    var dt1 = new Date(end.getFullYear(), end.getMonth(), end.getDate());

    var i = 0;
    while (dt1 >= start) {
      var col = document.createElement('th');
      col.setAttribute('class', (i < 1 ? '' : i > 2 ? 'hidden-md-down hidden-sm-down' : 'hidden-sm-down') + ' status-grid-header');
      col.innerHTML = FormatDate(dt1);
      row.appendChild(col);
      dt1 = new Date(dt1.getFullYear(), dt1.getMonth(), dt1.getDate() - 1);
      i++;
    }

    header.appendChild(row);

    tbl.appendChild(header);

    if (products) {
      for (var i = 0; i < products.length; ++i) {
        var row = CreateProductsGridEntry(products[i]);
        if (row) {
          body.appendChild(row);
        }
      }
    }

    tbl.appendChild(body);

    return tbl;
  }

  function FormatDate(dt) {
    if (dt) {
      return dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
    }
  }

  function CreateProductsGridEntry(p) {
    var row = document.createElement('tr');
    row.setAttribute('id', p.productid);
    row.setAttribute('parentid', p.parentid);
    row.setAttribute('style', 'height:30px;');

    var ncol = document.createElement('td');

    if (p.isparent > 0) {
      var cdata = document.createElement('div');
      cdata.setAttribute('style', 'font-size:16px;padding-right:10px;height:25px;float:right;padding-top:4px;cursor:pointer');
      cdata.setAttribute('class', 'sf-tip uxicon uxicon-drop-down');
      row.setAttribute('onclick', 'gdstatus.ExpandCollapseParent(\'' + p.productid + '\');');
      row.setAttribute('expand', '1');
      ncol.appendChild(cdata);
    } else if (p.ischild) {
      row.setAttribute('style', 'display:none;height:30px;');
      ncol.setAttribute('style', 'padding-left:60px;');
    } else {
      ncol.setAttribute('style', 'padding-left:40px;');
    }
    ncol.innerHTML += p.productname;
    row.appendChild(ncol);
    var c1 = document.createElement('td');
    c1.setAttribute('id', 'p-' + p.productid + '-0');
    c1.setAttribute('style', 'text-align:center;vertical-align:middle;');
    c1.innerHTML = '\u00A0';
    row.appendChild(c1);
    var c2 = document.createElement('td');
    c2.setAttribute('id', 'p-' + p.productid + '-1');
    c2.setAttribute('class', 'hidden-sm-down');
    c2.setAttribute('style', 'text-align:center;vertical-align:middle;');
    c2.innerHTML = '\u00A0';
    row.appendChild(c2);
    var c3 = document.createElement('td');
    c3.setAttribute('id', 'p-' + p.productid + '-2');
    c3.setAttribute('class', 'hidden-sm-down');
    c3.setAttribute('style', 'text-align:center;vertical-align:middle;');
    c3.innerHTML = '\u00A0';
    row.appendChild(c3);
    var c4 = document.createElement('td');
    c4.setAttribute('id', 'p-' + p.productid + '-3');
    c4.setAttribute('class', 'hidden-md-down hidden-sm-down');
    c4.setAttribute('style', 'text-align:center;vertical-align:middle;');
    c4.innerHTML = '\u00A0';
    row.appendChild(c4);
    var c5 = document.createElement('td');
    c5.setAttribute('id', 'p-' + p.productid + '-4');
    c5.setAttribute('class', 'hidden-md-down hidden-sm-down');
    c5.setAttribute('style', 'text-align:center;vertical-align:middle;');
    c5.innerHTML = '\u00A0';
    row.appendChild(c5);

    return row;
  }

  function CreateIssuesSummary() {
    if (openissues && openissues.length > 0) {
      var card = CreateCard('status-card');
      card.setAttribute('id', 'issuesummarycard');

      var row = document.createElement('div');
      row.setAttribute('class', 'row');
      row.setAttribute('style', 'margin-bottom:5px;');

      var imgcol = document.createElement('div');
      imgcol.setAttribute('class', 'col-sm-2 col-md-1 col-lg-1 hidden-sm-down');
      imgcol.setAttribute('style', 'text-align:right;');
      var img = document.createElement('div');
      img.setAttribute('class', 'uxicon uxicon-information');
      img.setAttribute('style', 'font-size:60px;margin:0px;color:#FF7811;');
      imgcol.appendChild(img);
      row.appendChild(imgcol);

      var textcol = document.createElement('div');
      textcol.setAttribute('class', 'col-sm-10 col-md-11 col-lg-11');
      var header = document.createElement('h2');
      header.setAttribute('style', 'margin:0px;');
      header.setAttribute('id', 'issuetitle');
      header.innerHTML = 'Ongoing Issues';
      textcol.appendChild(header);
      var status = document.createElement('small');
      status.setAttribute('style', 'margin:0px;');
      status.setAttribute('id', 'issuesubtitle');
      status.innerHTML = 'We are working dilligently to resolve known issues.';
      textcol.appendChild(status);
      row.appendChild(textcol);
      card.appendChild(row);

      var showhidediv = document.createElement('div');
      showhidediv.setAttribute('class', 'row');
      showhidediv.setAttribute('style', 'padding-top:10px;padding-bottom:10px;');
      showhidediv.setAttribute('onclick', 'gdstatus.ExpandCollapseSummary();');

      var showhideicon = document.createElement('span');
      showhideicon.setAttribute('id', 'showhideicon');
      showhideicon.setAttribute('class', 'sf-tip uxicon uxicon-drop-down col-md-1 col-lg-1 col-sm-1 col-xs-1');
      showhideicon.setAttribute('style', 'font-size:20px;padding-right:10px;padding-top:4px;height:25px;width:25px;');

      var showhide = document.createElement('div');
      showhide.setAttribute('id', 'showhide');
      showhide.setAttribute('class', 'col-md-11');
      showhide.setAttribute('style', 'font-size:20px;');

      showhide.setAttribute('state', isExpanded ? 'hidedetails' : 'showdetails');

      showhidediv.appendChild(showhideicon);
      showhidediv.appendChild(showhide);

      card.appendChild(showhidediv);

      var hidden = document.createElement('div');
      hidden.setAttribute('id', 'summary');
      hidden.setAttribute('class', 'row');
      hidden.setAttribute('style', isExpanded ? 'display:inherit;' : 'display:none;');
      hidden.setAttribute('issuedetail', isExpanded ? '1' : '0');

      var divide = document.createElement('div');
      divide.setAttribute('style', 'height:2px;display:inherit;background:#e6e6e6;');
      hidden.appendChild(divide);

      var locale = requestContext.market;

      var seen = {};

      for (var n = 0 ; n < openissues.length; ++n) {
        var issue = openissues[n];

        for (var i = 0 ; i < issue.products.length; ++i) {
          var pid = issue.products[i].productid;

          if (seen.hasOwnProperty(pid)) {
            continue;
          }

          seen[pid] = 1;

          var lastupdated = ToDate(issue.creationdate);
          var lastmsg = issue.message;

          if (!lastupdated) {
            continue;
          }

          for (var j = 0; j < issue.updates.length; ++j) {
            var dt = ToDate(issue.updates[j].creationtime);
            if (dt && dt > lastupdated) {
              lastupdated = dt;
              lastmsg = issue.updates[j].message;
            }
          }

          if (!lastmsg) {
            lastmsg = issue.message;
          }

          var details = document.createElement('div');
          details.setAttribute('style', 'padding-top:8px;padding-bottom:8px;display:inherit;');
          details.setAttribute('class', 'row');

          var link = document.createElement('a');
          link.setAttribute('class', 'sf-tip uxicon uxicon-radio-filled');
          link.setAttribute('style', 'font-size:14px;color:#FF7811;');
          link.setAttribute('href', window.location.href.split('?')[0] + '?productid=' + pid);
          link.setAttribute('title', issue.message);

          var linkdiv = document.createElement('div');
          linkdiv.setAttribute('class', 'col-md-1 col-lg-1 col-sm-1 col-xs-1');
          linkdiv.setAttribute('style', 'padding-top:14px;padding-left:36px;');
          linkdiv.appendChild(link);
          details.appendChild(linkdiv);

          var summary = document.createElement('div');
          summary.setAttribute('class', 'col-md-11 col-lg-11 col-sm-11 col-xs-11');

          var daterow = document.createElement('div');
          daterow.setAttribute('class', 'row');

          var datediv = document.createElement('div');
          datediv.setAttribute('class', 'col-md-12 col-lg-12 col-sm-12');
          datediv.setAttribute('style', 'font-size:12px;font-weight:700;');
          datediv.innerHTML = FormatDate(lastupdated);
          daterow.appendChild(datediv);
          summary.appendChild(daterow);

          var titlerow = document.createElement('div');
          titlerow.setAttribute('class', 'row');

          var titlediv = document.createElement('div');
          titlediv.setAttribute('class', 'col-md-12 col-lg-12 col-sm-12');
          titlediv.setAttribute('style', 'font-size:12px;font-weight:700;');
          titlediv.setAttribute('title', issue.message);
          titlediv.innerHTML = issue.message;
          titlerow.appendChild(titlediv);
          summary.appendChild(titlerow);

          var updaterow = document.createElement('div');
          updaterow.setAttribute('class', 'row');

          var updatediv = document.createElement('div');
          updatediv.setAttribute('class', 'col-md-12 col-lg-12 col-sm-12');
          updatediv.setAttribute('style', 'font-size:10px;');
          updatediv.innerHTML = lastmsg;
          updaterow.appendChild(updatediv);
          summary.appendChild(updaterow);

          details.appendChild(summary);
          hidden.appendChild(details);

          var line = document.createElement('div');
          line.setAttribute('style', 'height:2px;display:inherit;background:#e6e6e6;');
          hidden.appendChild(line);
          break;
        }
      }

      card.appendChild(hidden);

      return card;
    }
  }

  function AddIssueGridLinks() {
    if (openissues) {
      for (var n = 0 ; n < openissues.length; ++n) {
        var issue = openissues[n];
        for (var i = 0 ; i < issue.products.length; ++i) {
          var p = issue.products[i];
          if (p.hasOwnProperty('productid')) {
            var pid = p.productid;

            var idt = ToDate(issue.creationdate);
            idt.setHours(0, 0, 0, 0);
            if (idt) {
              var dt = GetUTCDate(new Date()); // Get the current date as utc
              dt.setHours(0, 0, 0, 0);

              var offset = Math.floor((dt - idt) / (1000 * 60 * 60 * 24));
              var element = document.getElementById('p-' + pid + '-' + offset);

              while (element) {
                if (element.innerHTML === '\u00A0' || element.innerHTML === '&nbsp;') {
                  element.innerHTML = '';

                  var link = document.createElement('a');
                  link.setAttribute('class', 'sf-tip uxicon uxicon-radio-filled');
                  link.setAttribute('style', 'font-size:14px;color:#FF7811;');
                  link.setAttribute('href', window.location.href.split('?')[0] + '?productid=' + pid);
                  link.setAttribute('title', issue.message);
                  element.appendChild(link);
                }

                var parent = element.parentElement;
                if (parent) {
                  var parentid = parent.getAttribute('parentid');
                  element = document.getElementById('p-' + parentid + '-' + offset);
                } else {
                  break;
                }
              }
            }
          }
        }
      }
    }

    if (issues) {
      for (var n = 0 ; n < issues.length; ++n) {
        var issue = issues[n];
        for (var i = 0 ; i < issue.products.length; ++i) {
          var p = issue.products[i];
          if (p.hasOwnProperty('productid')) {
            var pid = p.productid;

            var idt = ToDate(issue.creationdate);
            idt.setHours(0, 0, 0, 0);
            if (idt) {
              var dt = GetUTCDate(new Date()); // Get the current date as utc
              dt.setHours(0, 0, 0, 0);

              var offset = Math.floor((dt - idt) / (1000 * 60 * 60 * 24));
              var element = document.getElementById('p-' + pid + '-' + offset);

              while (element) {
                if (element.innerHTML === '\u00A0' || element.innerHTML === '&nbsp;') {
                  element.innerHTML = '';

                  var link = document.createElement('a');
                  link.setAttribute('class', 'sf-tip uxicon uxicon-ok');
                  link.setAttribute('style', 'font-size:14px;font-weight:700;color:#008a32;');
                  link.setAttribute('href', window.location.href.split('?')[0] + '?productid=' + pid);
                  link.setAttribute('title', issue.message);
                  element.appendChild(link);
                }

                var parent = element.parentElement;
                if (parent) {
                  var parentid = parent.getAttribute('parentid');
                  element = document.getElementById('p-' + parentid + '-' + offset);
                } else {
                  break;
                }
              }
            }
          }
        }
      }
    }
  }

  function GetUTCDate(dt) {
    if (dt) {
      return new Date(dt.getUTCFullYear(),
        dt.getUTCMonth(),
        dt.getUTCDate(),
        dt.getUTCHours(),
        dt.getUTCMinutes(),
        dt.getUTCSeconds(),
        dt.getUTCMilliseconds()
      );
    }
  }

  function ToDate(str) {
    if (str) {
      var data = str.split(' ');
      if (data.length === 2) {
        return new Date(data[0] + 'T' + data[1]);
      }
    }
  }

  function CreateCard(cardClass) {
    var thisCardClass = 'ux-card';
    if (cardClass) {
      thisCardClass += ' ' + cardClass;
    }
    var card = document.createElement('div');
    card.setAttribute('class', thisCardClass);
    card.setAttribute('style', 'background-color: #fff;');
    return card;
  }

  function ExpandCollapseSummary() {
    var summary = document.getElementById('summary');
    var icon = document.getElementById('showhideicon');
    var text = document.getElementById('showhide');

    if (summary && icon && text) {
      var detail = summary.getAttribute('issuedetail');
      if (detail) {
        if (detail === '1') {
          isExpanded = 0;
          summary.setAttribute('style', 'display:none');
          text.setAttribute('state', 'showdetails');
          icon.setAttribute('class', 'sf-tip uxicon uxicon-drop-down col-md-1 col-lg-1 col-sm-1 col-xs-1');
          detail = '0';
        } else {
          isExpanded = 1;
          summary.setAttribute('style', 'display:inherit;');
          text.setAttribute('state', 'hidedetails');
          icon.setAttribute('class', 'sf-tip uxicon uxicon-drop-up col-md-1 col-lg-1 col-sm-1 col-xs-1');
          detail = '1';
        }
        summary.setAttribute('issuedetail', detail);

        var state = text.getAttribute('state');
        if (state && locstr.hasOwnProperty(state)) {
          text.innerHTML = locstr[state];
        }
      }
    }
  }

  function LoadSupport() {
    window.open('https://sales.liveperson.net/hc/51516811/?cmd=file&amp;file=visitorWantsToChat&amp;site=51516811&amp;LEAppKey=f907f2d9acd64b7f8c00b83bed3c2822&amp;SV!chat-button-name=chat-godaddy-support-english&amp;SV!chat-button-room=chat-godaddy-support-english&amp;referrer=(button%20dynamic-button:chat-godaddy-support-english(GoDaddy%20Support%20%7C%20System%20Support%20%26%20Knowledge%20Base%20-%20GoDaddy))%20https%3A//support.godaddy.com/', 'newwindow', 'width=300, height=250');
    return !1;
  }

  function SortUpdatesComparison(a, b) {
    if (a && b && a.hasOwnProperty('creationtime') && b.hasOwnProperty('creationtime')) {
      var dt1 = ToDate(a.creationtime);
      var dt2 = ToDate(b.creationtime);
  	var dt3 = dt2 - dt1;
      if (dt3 === 0) {
        if (a && b && a.hasOwnProperty('updatekind') && b.hasOwnProperty('updatekind')) {
          dt1 = a.updatekind;
          dt2 = b.updatekind;
  		return dt2 - dt1;
        }
      } else {
        return dt3;
      }
    }
    return 0;
  }

  function ready() {
    var statusHeader = $('#statusheader');
    if (statusHeader.length) {
      var locale = requestContext.market;
      LocalizeText();
      LoadProducts(locale);
      LoadIssues(locale);
    }
  }

  window.gdstatus = window.gdstatus || {};
  window.gdstatus.LoadSupport = LoadSupport;
  window.gdstatus.ExpandCollapseParent = ExpandCollapseParent;
  window.gdstatus.ExpandCollapseSummary = ExpandCollapseSummary;

  $(document).ready(ready);

}(jQuery));

// jshint ignore: end
